import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import AuthProvider from "./hooks/AuthProvider";
import { bindThemeToDocument } from "./theme/theme";
import "./styles/global.css";

// Apply the persisted theme before the first paint to avoid a flash of the
// wrong theme. Must run before createRoot(...).render(...).
bindThemeToDocument();

const root = document.getElementById("root");
if (!root) {
  throw new Error(
    "Root element not found. Ensure index.html contains a <div id='root'></div>.",
  );
}

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
);
